"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const MarketplaceSpotlightIcon = createSVGIcon(
  <>
    <path
      d="M5.2666 20.2H11.6666"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 20.2018V9.53516"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0247 14.5605L16.0247 7.24609"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.40002 20.2V13.8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7333 28.7333H3.13333C2.56754 28.7333 2.02492 28.5085 1.62484 28.1084C1.22476 27.7084 1 27.1657 1 26.5999V3.13333C1 2.56753 1.22476 2.02491 1.62484 1.62484C2.02492 1.22476 2.56754 1 3.13333 1H18.2501C18.8155 1.00012 19.3578 1.22468 19.7577 1.62435L23.8423 5.70897C24.242 6.10889 24.4666 6.65112 24.4667 7.21652V10.6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8667 22.3334C14.8667 24.3137 15.6534 26.2128 17.0536 27.6131C18.4539 29.0134 20.3531 29.8 22.3334 29.8C24.3136 29.8 26.2128 29.0134 27.6131 27.6131C29.0134 26.2128 29.8 24.3137 29.8 22.3334C29.8 20.3531 29.0134 18.4539 27.6131 17.0536C26.2128 15.6534 24.3136 14.8667 22.3334 14.8667C20.3531 14.8667 18.4539 15.6534 17.0536 17.0536C15.6534 18.4539 14.8667 20.3531 14.8667 22.3334V22.3334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33 33.0013L27.5898 27.6367"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "MarketplaceSpotlightIcon",
  {
    viewBox: "0 0 34 34",
    titleAccess: "MarketplaceSpotlightIcon",
    fill: "none",
    color: "#888888",
  }
);
